import { createFileRoute } from '@tanstack/react-router';

import discordLfgAppTermsHtml from '#features/static-pages/assets/discord-lfg-app-terms-and-conditions.html?raw';
import { EmbeddedHtmlPage } from '#features/static-pages/components/EmbeddedHtmlPage';
import { legalPageOverrides } from '#features/static-pages/constants/legalPageOverrides';
import { staticPageHead } from '#features/static-pages/utils/head';
import { withLegalEnhancements } from '#features/static-pages/utils/legalEnhancements';

const title = 'Terms of Use for Teamplay LFG App for Discord';
const description =
  'Terms of use for the Teamplay LFG App for Discord, including usage scope, responsibilities, and conduct rules.';

export const Route = createFileRoute('/{-$locale}/_layout/discord-lfg-app/terms-and-conditions')({
  component: DiscordLfgAppTermsAndConditionsPage,
  head: () =>
    staticPageHead({
      title,
      description,
      pathname: '/discord-lfg-app/terms-and-conditions',
    }),
});

function DiscordLfgAppTermsAndConditionsPage() {
  const { locale } = Route.useParams();
  const localePrefix = locale === 'ru' ? '/ru' : '';
  const enhancedHtml = withLegalEnhancements(discordLfgAppTermsHtml, {
    fallbackUpdatedAt: 'Published on Teamplay.gg',
    quickLinks: [
      { href: `${localePrefix}/discord-lfg-app/privacy-policy`, label: 'App Privacy' },
      { href: `${localePrefix}/discord-lfg-app/terms-and-conditions`, label: 'App Terms' },
      { href: `${localePrefix}/terms-and-conditions`, label: 'Main Terms' },
    ],
  });

  return (
    <EmbeddedHtmlPage
      html={enhancedHtml}
      title="Discord LFG App Terms and Conditions"
      minHeight={950}
      extraStyles={legalPageOverrides}
      runInlineScripts
      shellWidth="980px"
      showReadingProgress
      showBackToTop
      enableSectionAnchors
    />
  );
}
